"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _RelateComputer = _interopRequireDefault(require("./RelateComputer"));

var _GeometryGraphOperation = _interopRequireDefault(require("../GeometryGraphOperation"));

var _RectangleContains = _interopRequireDefault(require("../predicate/RectangleContains"));

var _RectangleIntersects = _interopRequireDefault(require("../predicate/RectangleIntersects"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var RelateOp =
/*#__PURE__*/
function (_GeometryGraphOperati) {
  _inherits(RelateOp, _GeometryGraphOperati);

  function RelateOp() {
    var _this;

    _classCallCheck(this, RelateOp);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RelateOp).call(this));
    RelateOp.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(RelateOp, [{
    key: "getIntersectionMatrix",
    value: function getIntersectionMatrix() {
      return this._relate.computeIM();
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return RelateOp;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "covers",
    value: function covers(g1, g2) {
      if (g2.getDimension() === 2 && g1.getDimension() < 2) {
        return false;
      }

      if (g2.getDimension() === 1 && g1.getDimension() < 1 && g2.getLength() > 0.0) {
        return false;
      }

      if (!g1.getEnvelopeInternal().covers(g2.getEnvelopeInternal())) return false;

      if (g1.isRectangle()) {
        return true;
      }

      return new RelateOp(g1, g2).getIntersectionMatrix().isCovers();
    }
  }, {
    key: "intersects",
    value: function intersects(g1, g2) {
      if (!g1.getEnvelopeInternal().intersects(g2.getEnvelopeInternal())) return false;

      if (g1.isRectangle()) {
        return _RectangleIntersects.default.intersects(g1, g2);
      }

      if (g2.isRectangle()) {
        return _RectangleIntersects.default.intersects(g2, g1);
      }

      if (g1.isGeometryCollection() || g2.isGeometryCollection()) {
        var r = false;

        for (var i = 0; i < g1.getNumGeometries(); i++) {
          for (var j = 0; j < g2.getNumGeometries(); j++) {
            if (g1.getGeometryN(i).intersects(g2.getGeometryN(j))) {
              return true;
            }
          }
        }

        return false;
      }

      return new RelateOp(g1, g2).getIntersectionMatrix().isIntersects();
    }
  }, {
    key: "touches",
    value: function touches(g1, g2) {
      if (!g1.getEnvelopeInternal().intersects(g2.getEnvelopeInternal())) return false;
      return new RelateOp(g1, g2).getIntersectionMatrix().isTouches(g1.getDimension(), g2.getDimension());
    }
  }, {
    key: "relate",
    value: function relate() {
      if (arguments.length === 2) {
        var a = arguments[0],
            b = arguments[1];
        var relOp = new RelateOp(a, b);
        var im = relOp.getIntersectionMatrix();
        return im;
      } else if (arguments.length === 3) {
        var _a = arguments[0],
            _b = arguments[1],
            boundaryNodeRule = arguments[2];
        var relOp = new RelateOp(_a, _b, boundaryNodeRule);
        var im = relOp.getIntersectionMatrix();
        return im;
      }
    }
  }, {
    key: "overlaps",
    value: function overlaps(g1, g2) {
      if (!g1.getEnvelopeInternal().intersects(g2.getEnvelopeInternal())) return false;
      return new RelateOp(g1, g2).getIntersectionMatrix().isOverlaps(g1.getDimension(), g2.getDimension());
    }
  }, {
    key: "crosses",
    value: function crosses(g1, g2) {
      if (!g1.getEnvelopeInternal().intersects(g2.getEnvelopeInternal())) return false;
      return new RelateOp(g1, g2).getIntersectionMatrix().isCrosses(g1.getDimension(), g2.getDimension());
    }
  }, {
    key: "contains",
    value: function contains(g1, g2) {
      if (g2.getDimension() === 2 && g1.getDimension() < 2) {
        return false;
      }

      if (g2.getDimension() === 1 && g1.getDimension() < 1 && g2.getLength() > 0.0) {
        return false;
      }

      if (!g1.getEnvelopeInternal().contains(g2.getEnvelopeInternal())) return false;

      if (g1.isRectangle()) {
        return _RectangleContains.default.contains(g1, g2);
      }

      return new RelateOp(g1, g2).getIntersectionMatrix().isContains();
    }
  }]);

  return RelateOp;
}(_GeometryGraphOperation.default);

exports.default = RelateOp;

RelateOp.constructor_ = function () {
  this._relate = null;

  if (arguments.length === 2) {
    var g0 = arguments[0],
        g1 = arguments[1];

    _GeometryGraphOperation.default.constructor_.call(this, g0, g1);

    this._relate = new _RelateComputer.default(this._arg);
  } else if (arguments.length === 3) {
    var _g = arguments[0],
        _g2 = arguments[1],
        boundaryNodeRule = arguments[2];

    _GeometryGraphOperation.default.constructor_.call(this, _g, _g2, boundaryNodeRule);

    this._relate = new _RelateComputer.default(this._arg);
  }
};